module.exports = __webpack_public_path__ + "static/media/usage-stats.6edd198d.svg";